
import Component from '../../../assets/scripts/modules/component'

// Copy paste from Cook&Becker, credits to Jan de Groot
export default class LogoMarqueeComponent extends Component {
  init () {
    this.observedIntersectionElements = this.element.querySelectorAll('.logo-marquee__title, .logo-marquee__content, .logo-marquee__logos')
    this.marquee = this.element.querySelector('.logo-marquee__marquee')

    if (!this.marquee) {
      return
    }

    this.items = this.marquee.querySelectorAll('.picture')

    if (!this.items) {
      return
    }

    window.requestAnimationFrame(() => {
      for (let i = 0, j = 20; i < j; i++) {
        // Fill with some duplicates
        Array.from(this.items).forEach(element => element.parentNode.appendChild(element.cloneNode(true)))
      }

      this.marquee.classList.add('logo-marquee__marquee--visible')
    })
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.logo-marquee').forEach(element => {
  element.instance = element.instance || new LogoMarqueeComponent(element)
}))
